export default {
  home: {
    contentArea: 'Content area',
    title: 'wei qing university',
    index: 'Home',
    positions: 'Positions',
  },
}
